import { render, staticRenderFns } from "./PortalTeamItem.vue?vue&type=template&id=1417a6d8&"
import script from "./PortalTeamItem.vue?vue&type=script&lang=js&"
export * from "./PortalTeamItem.vue?vue&type=script&lang=js&"
import style0 from "./PortalTeamItem.vue?vue&type=style&index=0&id=1417a6d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports